module.exports = __webpack_public_path__ + "static/mais_aussi-1c3a059af7390dda3d9adf2e6fd3b897.png";